var treatment_reason = [
{'label': 'Adjuvan', 'value': 'adjuvant'},
{'label': 'Neoadjuvan', 'value': 'neoadjuvant'},
{'label': 'Definitif kemoradyoterapi', 'value': 'definitive_chemoradiotherapy'},
{'label': 'Metastatik, ileri evre', 'value': 'metastatic_advanced'}];

export { treatment_reason as options };
